import { ReactNode } from 'react'

export function IncompletedStepLabel({ children, icon }: { children: ReactNode; icon: ReactNode }) {
  return (
    <div className="flex items-center gap-3 py-0">
      <span className="flex h-6 w-6 shrink-0 items-center justify-center">{icon}</span>
      <span className="text-sm font-bold text-gray-700">{children}</span>
    </div>
  )
}
